import React from 'react';

interface IconVideo2Props {
    iconClasses?: string;
}

const IconVideo2: React.FC<IconVideo2Props> = ({ iconClasses }) => {
    return (
        <svg
            width="18"
            height="12"
            viewBox="0 0 18 12"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={`icon icon-video-2 ${iconClasses ?? ''}`}
            aria-hidden="true"
        >
            <path
                d="M17.25 2.25L12 6L17.25 9.75V2.25Z"
                stroke="currentColor"
                strokeWidth="1.5"
            />
            <path
                d="M10.5 0.75H2.25C1.42157 0.75 0.75 1.42157 0.75 2.25V9.75C0.75 10.5784 1.42157 11.25 2.25 11.25H10.5C11.3284 11.25 12 10.5784 12 9.75V2.25C12 1.42157 11.3284 0.75 10.5 0.75Z"
                stroke="currentColor"
                strokeWidth="1.5"
            />
        </svg>
    );
};

export default IconVideo2;
